import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import ScrollSmoother from 'gsap/ScrollSmoother'

gsap.registerPlugin(ScrollTrigger, ScrollSmoother)

function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
  
  function adjustDataSpeedForMobile() {
    if (isMobile()) {
      const elements = document.querySelectorAll('[data-speed]');
  
      elements.forEach(el => {
        el.setAttribute('data-speed', '1');
      });
    }
  }
  
  document.addEventListener('DOMContentLoaded', adjustDataSpeedForMobile);


createApp(App).use(createPinia()).use(router).mount('#app')
